const changelogObject = {
    button: null,
    popup: null,
    content: null,
    closeButton: null,
    status: -1,
    initialize: function () {
        if (this.status === 1) return;
        this.status = 1;

        this.button = document.querySelector('.updates__button');
        this.popup = document.querySelector('.changelog-popup');
        this.content = document.querySelector('.changelog-popup__content');
        this.closeButton = document.querySelector('.changelog-popup__close-button');

        this.button.addEventListener('click', this.showPopup.bind(this));
        this.popup.addEventListener('click', this.hidePopup.bind(this));
        this.closeButton.addEventListener('click', this.hidePopup.bind(this));

        main.ajax('/ajax/changelog', this.setContent.bind(this), {'project': 'instaforex'});
    },
    setContent: function (responseText) {
        this.content.innerHTML = responseText;
    },
    showPopup: function () {
        this.popup.classList.add('_show');
        blockingScrollObject.start();
    },
    hidePopup: function (e) {
        let event = e || window.event;
        if (event.target !== this.closeButton && event.target !== this.popup) return;

        this.popup.classList.remove('_show');
        blockingScrollObject.stop();
    }
};
